/* Not authenticated paths */

export const authPaths = {
  authentication: '/authentication',
};

/* Global view paths */

export const globalPaths = {
  profile: { path: '/profile', crumb: 'My profile' },
  changePassword: { path: '/change-password', crumb: 'Change password' },
  dashboard: { path: '/dashboard', crumb: 'Dashboard' },
  companyDeductionsReportProfile: {
    path: '/payrolls/company-reports/:deductionsReportId',
    crumb: 'Company report',
  },
  individualDeductionsReportProfile: {
    path: '/payrolls/individual-reports/:individualDeductionsReportId',
    crumb: 'Individual report',
  },
  suspiciousActivity: { path: '/suspicious-activity', crumb: 'Suspicious activity' },
  companies: { path: '/company-selection', crumb: 'Company selection' },
  employees: { path: '/employees', crumb: 'Employees' },
  employeeProfile: { path: '/employees/:individualId', crumb: 'Employee name' },
  importEmployees: { path: '/employees/import-employees', crumb: 'Upload data' },
  payrollReports: { path: '/payrolls', crumb: 'Deduction reports' },
  reconciliations: { path: '/reconciliations', crumb: 'Reconciliations' },
  reconciliationProfile: { path: '/reconciliations/:reconciliationId', crumb: 'Reconciliation' },
  salaryReconciliationProfile: {
    path: '/reconciliations/salary/:reconciliationId',
    crumb: 'Salary reconciliation',
  },
  admins: { path: '/admins', crumb: 'Admins' },
  adminProfile: { path: '/admins/:individualId', crumb: 'Admin name' },
  merchants: { path: '/merchants', crumb: 'Merchants' },
  approvals: { path: '/approvals', crumb: 'Approvals' },
  partners: { path: '/partners', crumb: 'Partners' },
  systemSettings: { path: '/system-settings', crumb: 'System settings' },
  syncHistory: { path: '/sync-history', crumb: 'Sync history' },
};

/* Company view paths */

export const companyPaths = {
  home: { path: '/company-selection/:companyId', crumb: 'Company name' },
  notifications: {
    path: '/company-selection/:companyId/notifications',
    crumb: 'Notifications',
  },
  dashboard: { path: '/company-selection/:companyId/dashboard', crumb: 'Dashboard' },
  companyDeductionsReportProfile: {
    path: '/company-selection/:companyId/payroll-reports/company-reports/:deductionsReportId',
    crumb: 'Company report',
  },
  individualDeductionsReportProfile: {
    path: '/company-selection/:companyId/payroll-reports/individual-reports/:individualDeductionsReportId',
    crumb: 'Individual report',
  },
  analytics: { path: '/company-selection/:companyId/analytics', crumb: 'Analytics' },
  employees: { path: '/company-selection/:companyId/employees', crumb: 'Employees' },
  employeeProfile: {
    path: '/company-selection/:companyId/employees/:individualId',
    crumb: 'Employee name',
  },
  importEmployees: {
    path: '/company-selection/:companyId/employees/import-employees',
    crumb: 'Upload data',
  },
  payrollReports: {
    path: '/company-selection/:companyId/payroll-reports',
    crumb: 'Deduction reports',
  },
  reconciliations: {
    path: '/company-selection/:companyId/reconciliations',
    crumb: 'Reconciliations',
  },
  reconciliationProfile: {
    path: '/company-selection/:companyId/reconciliations/:reconciliationId',
    crumb: 'Reconciliation',
  },
  salaryReconciliationProfile: {
    path: '/company-selection/:companyId/reconciliations/salary/:reconciliationId',
    crumb: 'Salary reconciliation',
  },
  payCalendars: {
    path: '/company-selection/:companyId/pay-calendars',
    crumb: 'Pay calendars',
  },
  payCalendarProfile: {
    path: '/company-selection/:companyId/pay-calendars/:payCalendarId',
    crumb: 'Pay calendar name',
  },
  admins: { path: '/company-selection/:companyId/admins', crumb: 'Admins' },
  adminProfile: {
    path: '/company-selection/:companyId/admins/:individualId',
    crumb: 'Admin name',
  },
  gifting: { path: '/company-selection/:companyId/gifting', crumb: 'Gifting' },
  rewardEmployees: {
    path: '/company-selection/:companyId/reward-employees',
    crumb: 'Reward employees',
  },
  recognitions: {
    path: '/company-selection/:companyId/recognitions',
    crumb: 'Reward & Recognition',
  },
  prides: {
    path: '/company-selection/:companyId/recognitions/prides',
    crumb: 'Prides',
  },
  theRoar: {
    path: '/company-selection/:companyId/recognitions/the-roar',
    crumb: 'The Roar',
  },
  recognitionApprovals: {
    path: '/company-selection/:companyId/recognitions/approvals',
    crumb: 'Approvals',
  },
  campaigns: {
    path: '/company-selection/:companyId/recognitions/campaigns',
    crumb: 'Campaigns',
  },
  campaignDetail: {
    path: '/company-selection/:companyId/recognitions/campaigns/:campaignId',
    crumb: 'Campaign',
  },
  campaignPrideDetail: {
    path: '/company-selection/:companyId/recognitions/campaigns/:campaignId/prides/:prideCampaignId',
    crumb: 'Pride',
  },
  recognitionSettings: {
    path: '/company-selection/:companyId/recognitions/settings',
    crumb: 'Settings',
  },
  walletsAndPots: {
    path: '/company-selection/:companyId/wallets-and-pots',
    crumb: 'Wallets & Pots',
  },
  pot: {
    path: '/company-selection/:companyId/wallets-and-pots/:potId',
    crumb: 'Pot',
  },
  uploadedFiles: { path: '/company-selection/:companyId/uploaded-files', crumb: 'Uploaded files' },
  settings: {
    path: '/company-selection/:companyId/settings',
    crumb: 'Settings',
  },
};
